import { render, staticRenderFns } from "./accountBalance.vue?vue&type=template&id=e5298796&"
import script from "./accountBalance.vue?vue&type=script&lang=ts&"
export * from "./accountBalance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports